<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="flyAmericaActObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">Fly America Act</p>
                    <p>Trigger for non-compliant flights.</p>
                    <p>Open Sky Agreement carriers are
                        <span class="rule-config-variable" @click="isEdit = !isEdit">{{ openSkiesLabel }}&nbsp;<b-icon
                                icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="flyAmericaActObj.isActive" v-model="flyAmericaActObj.isActive"
                        @input="toggleFlyAmericaActCompliance" :left-label="true">{{ flyAmericaActObj.isActive ? 'Active' :
                            'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <FlyAmericaStatus :allowOpenSkyVal="openSkiesAllowed" @emitOpenSkyData="getOpenSkyValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
    </div>
</template>
<script>
import FlyAmericaStatus from "../CommonRules/FlyAmericaStatus.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: { FlyAmericaStatus },
    data() {
        return {
            flyAmericaActObj: this.value
                ? this.value
                : {
                    name: "flyAmericaActCompliance",
                    isActive: false,
                    type: "air",
                    message: "Trigger for flights not compliant with Fly America Act",
                    value: ["usCompliant", "openSkiesCompliant"]
                },
            isEdit: false,
            openSkyValue: null
        };
    },
    methods: {
        toggleFlyAmericaActCompliance() {
            this.$emit("flyAmericaActCompliance", this.flyAmericaActObj);
        },
        getOpenSkyValue(val) {
            this.openSkyValue = val;
        },
        toggleOpenSky() {
            // Check if 'openSkiesCompliant' is toggled
            const shouldIncludeOpenSkies = this.openSkyValue === true;

            if (shouldIncludeOpenSkies) {
                // Add 'openSkiesCompliant' to this.flyAmericaActObj.value if it is not already there
                if (!this.flyAmericaActObj.value.includes('openSkiesCompliant')) {
                    this.flyAmericaActObj.value.push('openSkiesCompliant');
                }
            } else {
                // Remove 'openSkiesCompliant' from this.flyAmericaActObj.value
                this.flyAmericaActObj.value = this.flyAmericaActObj.value.filter(value => value !== 'openSkiesCompliant');
            }
        },
        saveCall() {
            this.isEdit = false;

            this.toggleOpenSky();
        },
    },
    mounted() {
        this.flyAmericaActObj.type = "air";
        this.flyAmericaActObj.message = this.buildMessage;
        this.$emit("flyAmericaActCompliance", this.flyAmericaActObj);
    },
    computed: {
        buildMessage() {
            var string = "Trigger for flights not compliant with the Fly America Act";

            return string;
        },
        openSkiesAllowed() {
            return this.flyAmericaActObj.value.includes('openSkiesCompliant');
        },
        openSkiesLabel() {
            return this.openSkiesAllowed ? 'allowed' : 'not allowed';
        }

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    this.flyAmericaActObj = this.value;
                }
                this.flyAmericaActObj.type = "air";
                this.flyAmericaActObj.message = this.buildMessage;
                this.$emit("flyAmericaActCompliance", this.flyAmericaActObj);

            },
            deep: true,
        },
    },
};
</script>
  